<template>
  <div id="app">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'app',
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title;
      },
    },
  },
});
</script>

<style>
@import url("./assets/css/app.css");
@import url("./assets/css/bootstrap-grid.css");
@import url("./assets/css/styles.css");
</style>
